export default __webpack_public_path__ + "bd9168bd6ac8620fed54516ce047c565.png";